<div class="filter-chips-bar" *ngIf="chips.length > 0">
  <span class="filter-chip" *ngFor="let chip of chips">
    {{ chip.label | translate }}: {{ chip.displayValue | translate }}
    <span *ngIf="!chip.disabled" class="filter-chip-x" (click)="onRemove(chip)" role="button" aria-label="Remove filter">&#10005;</span>
  </span>
  <span class="filter-chip-clearall" (click)="onClearAll()" role="button">
    {{ 'text.clearAll' | translate }} &#10005;
  </span>
</div>
